
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"47","height":"16","viewBox":"0 0 47 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.076 7.517H.756","stroke":"#000","stroke-width":"1.583","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M46.65 7.517C42.14 5.855 36.601 3.007 33.12 0l2.69 7.517-2.69 7.517c3.481-3.007 9.02-5.855 13.53-7.517z","fill":"#000"}})])
          )
        }
      }
    